import AirDatepicker from 'air-datepicker';
import localePl from 'air-datepicker/locale/pl';
import Inputmask from 'inputmask';
import 'air-datepicker/air-datepicker.css';
/**
 * Initializes an AirDatepicker instance on a single input element.
 *
 * @param {HTMLElement} element The visible input element to initialize.
 */
function initAirDatepicker(element) {
    if (element.datepicker || element.dataset.adpInitialized) {
        return;
    }

    const hiddenInputSelector = element.dataset.altFieldFor;
    const hiddenInput = document.querySelector(hiddenInputSelector);

    if (!hiddenInput) {
        console.error('Could not find the main input for', element);
        return;
    }

    hiddenInput.type = 'hidden';

    let todayButton = {
        content: gettext('Dzisiaj'),
        onClick: (dp) => {
            const date = new Date();
            dp.selectDate(date);
            dp.setViewDate(date);
        },
    };

    const datepickerOptions = {
        locale: localePl,
        autoClose: true,
        keyboardNav: true,
        dateFormat: 'dd.MM.yyyy', // Format for the visible input
        altField: hiddenInput,
        altFieldDateFormat: 'yyyy-MM-dd', // Format for the hidden input
        buttons: ['clear', todayButton],
    };

    const dp = new AirDatepicker(element, datepickerOptions);

    if (hiddenInput.value) {
        dp.selectDate(hiddenInput.value, {
            updateTime: false,
            silent: true,
        });
    }

    const im = new Inputmask({
        alias: 'datetime',
        inputFormat: 'dd.mm.yyyy',
        placeholder: gettext('DD.MM.RRRR'),
    });
    im.mask(element);

    element.addEventListener('change', () => {
        const selectedDate = dp.selectedDates[0];

        if (element.value === '') {
            if (selectedDate) {
                dp.clear();
            }
            return;
        }

        const dateParts = element.value.split('.');
        if (dateParts.length === 3) {
            const day = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10) - 1;
            const year = parseInt(dateParts[2], 10);
            const newDate = new Date(year, month, day);
            if (!isNaN(newDate.getTime())) {
                newDate.setHours(0, 0, 0, 0);
                if (selectedDate) {
                    const selectedDateNormalized = new Date(selectedDate);
                    selectedDateNormalized.setHours(0, 0, 0, 0);

                    if (
                        selectedDateNormalized.getTime() === newDate.getTime()
                    ) {
                        return;
                    }
                }

                dp.selectDate(newDate, {
                    updateTime: false,
                    silent: true,
                });
            }
        }
    });

    element.dataset.adpInitialized = 'true';
}

/**
 * Finds and initializes all AirDatepicker inputs, both on initial page load
 * and those added dynamically to the DOM later.
 */
function setupAirDatepicker() {
    document
        .querySelectorAll('.air-datepicker-input')
        .forEach(initAirDatepicker);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                try {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.matches('.air-datepicker-input')) {
                            initAirDatepicker(node);
                        }
                        node.querySelectorAll('.air-datepicker-input').forEach(
                            initAirDatepicker,
                        );
                    }
                } catch (e) {
                    console.warn(
                        'Could not access node properties. This is likely due to a browser extension.',
                    );
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAirDatepicker);
} else {
    setupAirDatepicker();
}
